"use client";

import type { PathParams } from "./types";
import { useRouteParams } from "./useRouteParams";
import type { GetPathWithTemplate } from "./utils";

export function useUrlParams<T extends string>(
  _getPath: GetPathWithTemplate<T>
) {
  return useRouteParams<PathParams<T>>();
}
